import withMountGuard from 'hocs/withMountGuard'
import { useAppSelector } from 'hooks/reduxHooks'
import React from 'react'
import AccountMenuLoyaltyHasAccountDetailsTile from './AccountMenuLoyaltyHasAccountDetailsTile'
import AccountMenuLoyaltyDetailsTileSkeleton from './AccountMenuLoyaltyDetailsTileSkeleton'
import useLoyaltyUserEligibilityTier from 'loyalty/hooks/useLoyaltyUserEligibilityTier'
import AccountMenuLoyaltyNoAccountDetailsTiles from './AccountMenuLoyaltyNoAccountDetailsTiles'
import getHasLoyaltyAccount from 'loyalty/selectors/getHasLoyaltyAccount'
import getIsLoyaltyEnabled from 'loyalty/selectors/getIsLoyaltyEnabled'

interface Props {
  onLinkClick: () => void
}

function AccountMenuLoyaltyTiles({ onLinkClick }: Props) {
  const hasLoyaltyAccount = useAppSelector(getHasLoyaltyAccount)
  const loyaltyAccount = useAppSelector(state => state.loyalty.account)
  const [eligibilityTier, fetchingEligibility, fetchingEligibilityError] = useLoyaltyUserEligibilityTier()
  const showNoAccountDetailsTile =
    eligibilityTier &&
    !hasLoyaltyAccount &&
    !fetchingEligibility &&
    !fetchingEligibilityError

  if (loyaltyAccount.error) {
    return null
  }

  if (loyaltyAccount.fetching) {
    return <AccountMenuLoyaltyDetailsTileSkeleton />
  }

  return (
    <>
      {showNoAccountDetailsTile &&
        <AccountMenuLoyaltyNoAccountDetailsTiles
          eligibilityTier={eligibilityTier}
          onLinkClick={onLinkClick}
        />
      }
      {hasLoyaltyAccount && loyaltyAccount.data &&
        <AccountMenuLoyaltyHasAccountDetailsTile
          onLinkClick={onLinkClick}
          loyaltyAccountData={loyaltyAccount.data}
        />
      }
    </>
  )
}

export default withMountGuard(() => {
  return useAppSelector(getIsLoyaltyEnabled)
})(AccountMenuLoyaltyTiles)
